import { render, staticRenderFns } from "./PersonalProfilePage.vue?vue&type=template&id=18e0037c&scoped=true&"
import script from "./PersonalProfilePage.vue?vue&type=script&lang=js&"
export * from "./PersonalProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e0037c",
  null
  
)

export default component.exports